import { createSelector } from 'reselect';
import { v2 } from '@saucelabs/sl-module-builds';

import { eventMetaDataSelector } from '../common/selectors';

export const builds = (store) => store.apps.builds.rdc;
export const authCheckSelector = createSelector([
  (store) => store.user,
  (store) => store.apps.builds.rdc,
  (store) => store.router.location,
],
(user, rdc, location) => ({
  isAuthenticated: user.isAuthenticated() || rdc.getIn(['build', 'public']),
  currentPathname: location.pathname,
}));

export const latestJobModifiedTime = createSelector([
  (store) => store.apps.builds.rdc,
],
(rdc) => {
  const sortedJobs = rdc.get('jobs').valueSeq().sortBy((job) => job.get('modification_time'));
  return sortedJobs.size ? sortedJobs.last().get('modification_time') : null;
});

export const rdcContainerSelector = createSelector([
  (store) => store.apps.builds.rdc,
  (store) => store.user,
  (store) => store.apps.builds.common,
  latestJobModifiedTime,
  eventMetaDataSelector,
],
(rdc, user, common, modifiedSince, eventMetaData) => ({
  isInitialized: rdc.get('initialized'),
  loading: common.get('loading'),
  jobsLoading: rdc.get('jobsLoading'),
  build: rdc.get('build'),
  jobs: rdc.get('jobs'),
  isOpenSauceUser: !user.isAuthenticated(),
  isOwner: rdc.getIn(['build', 'owner']) === user.get('username'),
  modifiedSince,
  eventMetaData: {
    ...eventMetaData,
    sku_type: 'RDC',
  },
}));

export const jobsQueryParamSelector = createSelector([
  (store) => store.apps.builds.rdc,
  latestJobModifiedTime,
],
(rdc, modifiedSince) => ({
  build: rdc.get('build'),
  ...(modifiedSince ? { modified_since: modifiedSince } : null),
}));

export const getUsername = v2.buildsList.selectors.createGetUsername(builds);
export const isInitialized = v2.buildsDetail.selectors.createIsInitialized(builds);
export default rdcContainerSelector;
